module.exports = __webpack_public_path__ + "static/media/modal_sign_right_intro.e58f3f0d.png";